import helper from './helper'

const getReferenceUrlWithParameters = helper.getReferenceUrlWithParameters
export default {
  getReferenceUrlWithParameters,
  /**
   * Базовая функция для построения урл
   */
  getByRecievedUrlData: (url, gets = null) => getReferenceUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  CONTACTS: {
    PERSONAL: {
      LIST: (gets = null) => getReferenceUrlWithParameters(
        /**
         * Получает список персонала
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка персонала
         */
        'employee|contacts|personal-list',
        'list',
        null,
        gets
      ),
      ISSUE: (id, gets = null) => getReferenceUrlWithParameters(
        /**
         * Получает проблему персонала или создает отчет о проблеме
         * @param {string|number} id - идентификатор сотрудника
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для работы с проблемами персонала
         */
        'employee|contacts|personal-issue',
        'issue',
        { id },
        gets
      ),
    },
  },
}
